export const VISITOR_BASE_URL = "/visitors"
export const VISITOR_ONBOARDING_BASE_URL = "/visitors/onboarding"

export const VISITOR_PATHS = {
  START: "start",
  NAME: "name",
  SCAN: "scan",
  CHECKOUT: "checkout",
  FIELDS: "fields",
  HEALTH_INFO: "health_info",
  HEALTH: "health",
  DOCUMENT_INFO: "document_info",
  DOCUMENT: "document",
  PHOTO_INFO: "photo_info",
  PHOTO: "photo",
  FINISH: "finish",
  BADGE_SELECT: "badge_select",
  BADGE_PRINT: "badge_print",
  BADGE_E_PAPER: "badge_epaper",
  PRINT: "print",
} as const

export const visitorRegistrationUrl = (
  segment: (typeof VISITOR_PATHS)[keyof typeof VISITOR_PATHS],
) => `${VISITOR_BASE_URL}/${segment}`

export const visitorRegistrationFinishUrl = (finishType: string) =>
  `${VISITOR_BASE_URL}/${VISITOR_PATHS.FINISH}/${finishType}`

export const VISITOR_ONBOARDING_PATHS = {
  CONFIRMATION: "confirmation",
  ASSIGN_LOCATION: "assign_location",
  PIN: "pin",
} as const

export const visitorOnboardingPath = (segment: string) =>
  `${VISITOR_ONBOARDING_BASE_URL}/${segment}`

export const visitorOnboardingPinUrl = (pin: string) =>
  `${VISITOR_ONBOARDING_BASE_URL}/${VISITOR_ONBOARDING_PATHS.PIN}/${pin}`

export const BADGE_MODE = {
  PRINT: "print",
  E_PAPER_BADGE: "ePaperBadge",
} as const
